/**
 * ValidityCard — Card "Validité" (durée du devis en jours).
 * Phase 3i : utilise BENumericInput pour comportement uniforme (focus-select, blur→0, pas de "0 indélébile").
 */
import { Card, CardContent } from "@/components/ui/card";
import BENumericInput from "@/components/quote/BENumericInput";

export default function ValidityCard({ quote, setQuote, isDraft }) {
  return (
    <Card className="border-slate-800 bg-slate-900/40">
      <CardContent className="space-y-2 p-4">
        <h3 className="text-xs uppercase tracking-wider text-slate-500">Validité</h3>
        <div className="flex items-center gap-2">
          <BENumericInput
            value={quote.validity_days}
            onChange={(n) =>
              setQuote({ ...quote, validity_days: Math.max(1, Math.min(365, Math.round(n))) })
            }
            disabled={!isDraft}
            className="w-24 border-slate-700 bg-slate-950/40 text-slate-100"
            data-testid="quote-validity-days"
          />
          <span className="text-sm text-slate-400">jours</span>
        </div>
      </CardContent>
    </Card>
  );
}
